import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import { Trash } from '@liveauctioneers/hammer-ui-core/icons';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import * as React from 'react';

import { useAppSelector } from '@/redux/hooks';
import { getSellerName } from '@/redux/modules/seller';
import { getSellerCatalogCounts } from '@/redux/modules/sellerCatalogCounts';
import { getSellerUrl } from '@/utils/urls';

import TableRow from './Components/TableRow';

type Props = {
    sellerId: number;
};

const FollowedSellerRow = ({ sellerId }: Props) => {
    const name = useAppSelector((state) => getSellerName(state, sellerId));
    const catalogCounts = useAppSelector((state) => getSellerCatalogCounts(state, sellerId));
    return (
        <TableRow
            email={
                <IconButton
                    icon={Trash}
                    size="sm"
                />
            }
            frequency={
                catalogCounts.upcomingCount === 0 ? <FormattedMessage id="no_upcoming" /> : catalogCounts.upcomingCount
            }
            key={name}
            sellerId={sellerId as number}
            type={
                <Link
                    route
                    to={getSellerUrl(sellerId, name)}
                >
                    {name}
                </Link>
            }
        />
    );
};

export default FollowedSellerRow;
